export const getCookie = (name: string): string | undefined =>
  // return the second (group) which contains the value
  document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))?.[2]
